import React from "react";
import { motion } from "framer-motion";

const images = [
  "/images/gallery/mth1.JPG",
  "/2026/BBND5219.JPG",
  "/images/gallery/mth2.JPG",
  "/2026/BBND5234.JPG",
  "/images/gallery/mth3.JPG",
  "/images/gallery/mth4.JPG",
];

export default function MarathonGallery() {
  return (
    <section className="py-12 sm:py-16 bg-gray-50 px-4 sm:px-6 lg:px-12 mt-12 sm:mt-16 md:mt-20">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row gap-10 items-stretch">
        
        {/* Left Text */}
        <div className="md:w-1/2 text-center md:text-left px-2 sm:px-4 flex flex-col justify-center">
          <h2 className="text-2xl sm:text-3xl font-bold text-brandRed mb-4">
            Mini Marathon Highlights
          </h2>
          <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
            For over a decade, Nanbhat Janhit Society has been bringing the community together through its annual Janhit Mini Marathon, an event that now draws more than 1,000 participants every year. Each edition carries a powerful social theme — from women empowerment to cancer awareness — and this year’s concept, “Run of Youth, Strength of Society,” celebrates the role of young people in building a stronger future.
            <br /><br />
            More than just a sporting event, the marathon has grown into a movement of unity, health, and awareness. It has created a platform where people of all ages and backgrounds come together to run for a cause, fostering solidarity and shared responsibility within the community.
            <br /><br />
            Through the Mini Marathon, Nanbhat Janhit Society continues to inspire change, raise awareness, and strengthen the very fabric of society — proving that when a community runs together, it truly grows together.
          </p>

          {/* Register Button */}
          <div className="mt-8 flex justify-center md:justify-start">
            <a
              href="https://forms.gle/L5LzaPyM5tRgtQ1i9"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-brandRed hover:bg-red-700 text-white font-semibold text-base sm:text-lg py-3 px-8 rounded-full shadow-lg transition-all duration-300 hover:scale-105"
            >
              <span>Register for Marathon Now</span>
              <svg
                className="w-5 h-5 ml-1"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                />
              </svg>
            </a>
          </div>
        </div>

        {/* Right Image Scroll */}
        <div className="md:w-1/2 overflow-hidden relative flex items-center">
          <motion.div
            className="flex"
            animate={{ x: ["0%", "-50%"] }}
            transition={{ duration: 25, repeat: Infinity, ease: "linear" }}
          >
            {images.concat(images).map((img, index) => (
              <div
                key={index}
                className="flex-shrink-0 rounded-xl overflow-hidden shadow-lg"
                style={{
                  width: "280px",
                  height: "100%", // Fill height equal to left div
                  marginRight: "16px",
                }}
              >
                <img
                  src={img}
                  alt={`Marathon ${index + 1}`}
                  className="w-full h-full object-cover"
                />
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
